export default {
      id: "i-list-usage",
      viewBox: "0 0 20 11",
      url: __webpack_public_path__ + "img/sprite.svg#i-list",
      toString: function () {
        return this.url;
      }
    }